import React from "react";
import CtaSecondaryRight from "../../components/buttons/CtaSecondaryRight";
import CtaPrimary from "../../components/buttons/CtaPrimary";
import CtaMedia from "../../components/buttons/CtaMedia";

const RightTextToCard = (props) => {
  function checkInsertedCta() {
    if (props.insertCta === "primary") {
      return (
        <CtaPrimary
          href={props.href}
          text={props.buttonText}
          style={props.buttonStyle}
        />
      );
    } else if (props.insertCta === "secondary") {
      return <CtaSecondaryRight href={props.href} text={props.buttonText} />;
    } else if (props.insertCta === "media") {
      return (
        <CtaMedia
          text={props.buttonText}
          btnId={props.btnId}
          url={props.url}
          target={props.target}
          modalId={props.modalId}
          label={props.label}
          iframeId={props.iframeId}
        />
      );
    } else return;
  }

  function ValueProp(props) {
    return (
      <li>
        <img src={props.img} alt={props.alt ? props.alt : props.title} />
        <span dangerouslySetInnerHTML={{ __html: props.title }}></span>
      </li>
    );
  }

  function ValuePropList(props) {
    const valueProps = props.valueProps;
    return (
      <ul className="rightTextToCard_list">
        {valueProps.map((valueProp) => (
          <ValueProp
            key={"item-" + valueProp.title}
            img={valueProp.img}
            title={valueProp.title}
            alt={valueProp.alt}
          />
        ))}
      </ul>
    );
  }

  return (
    <div className={`${props.className} rightTextToCardContainer`}>
      {props.img ? (
        <img id="rightTextToCard_img" src={props.img} alt={props.alt} />
      ) : (
        <video
          width="100%"
          id="rightTextToCard_video"
          playsInline="playsinline"
          autoPlay="autoplay"
          muted="muted"
          loop="loop"
        >
          <source src={props.videoSrc} type="video/mp4" />
        </video>
      )}
      <div className="rightTextToCard_textContainer">
        <div className="title-wrapper">
          {props.icon && (
            <img
              id="rightTextToCard_icon"
              src={props.icon}
              alt={props.iconAlt}
            />
          )}
          <h3 id="rightTextToCard_title">{props.title}</h3>
        </div>
        <p id="rightTextToCard_desc">{props.description}</p>
        {props.valueProps && <ValuePropList valueProps={props.valueProps} />}
        {checkInsertedCta()}
      </div>
    </div>
  );
};

export default RightTextToCard;
